module.exports = __webpack_public_path__ + "static/media/tools-image.64aebc9f.svg";